module.exports = __webpack_public_path__ + "static/media/Edit.090a1744.svg";